import React from 'react';
import Card from '../Card';
import { onRequestPhoneCall } from '../../helpers/validationHelper';

const ContactCard = ({ contact }) => (
  <Card
    title="Contact Information"
    body={(
      <>
        <div>{contact.description}</div>
        <div>{onRequestPhoneCall(contact.phone)}</div>
        <div>{contact.office}</div>
        <div>{contact.email}</div>
      </>
    )}
  />
);

export default ContactCard;
